import { LoadingButton } from '@atlaskit/button';
import { deleteVendorResponse } from '@atlassian/mpac-api-client';
import { UserGeneratedHtml } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { useAsync } from 'react-async';
import { Actions, EditButton, Logo, LogoWrapper, Name, Response, ResponseContainer, ResponseWrapper } from "./VendorResponse.styles";
import vendorDefaultLogo from "./vendor-default-logo.png";
export const VendorResponse = ({
  name,
  logo,
  response,
  vendorResponseEndpoint,
  mpacBaseUrl,
  handleDeletedVendorResponse,
  onEditVendorResponse,
  permissions,
  preloadVendorResponseEditor
}) => {
  const {
    isPending: isDeleteVendorResponseInProgress,
    isFulfilled: isDeleteVendorResponseSuccessful,
    isRejected: isDeleteVendorResponseRejected,
    error: deleteVendorResponseError,
    run: runDeleteVendorResponse
  } = useAsync({
    deferFn: deleteVendorResponse
  });
  useEffect(() => {
    if (isDeleteVendorResponseRejected) log.error('ReviewsTab', 'failed to delete vendor response', {
        deleteVendorResponseError
      });
  }, [isDeleteVendorResponseRejected]);
  useEffect(() => {
    if (isDeleteVendorResponseSuccessful) {
      handleDeletedVendorResponse();
    }
  }, [isDeleteVendorResponseSuccessful]);
  const onDeleteVendorResponse = e => {
    e.preventDefault();
    if (vendorResponseEndpoint) {
      const responseUrl = "".concat(mpacBaseUrl).concat(vendorResponseEndpoint);
      runDeleteVendorResponse(responseUrl);
    }
  };
  return /*#__PURE__*/React.createElement(ResponseWrapper, null, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(Logo, {
    src: logo !== null && logo !== void 0 ? logo : vendorDefaultLogo,
    alt: "Vendor Logo"
  })), /*#__PURE__*/React.createElement(ResponseContainer, null, name ? /*#__PURE__*/React.createElement(Name, null, name) : null, /*#__PURE__*/React.createElement(Response, null, response ?
  /*#__PURE__*/
  React.createElement(UserGeneratedHtml, {
    dangerousHtml: response,
    style: {
      fontSize: '14px'
    }
  }) : null), permissions ? /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(EditButton, {
    appearance: "link",
    spacing: "none",
    onClick: onEditVendorResponse,
    onMouseEnter: preloadVendorResponseEditor
  }, "Edit"), /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "link",
    isLoading: isDeleteVendorResponseInProgress,
    spacing: "none",
    onClick: onDeleteVendorResponse,
    "aria-label": "Delete Vendor Response"
  }, "Delete")) : null));
};